<template>
  <div class="mb-8 flex flex-col w-full">
    <div class="text-center sm:text-left">
      <h2 class="text-balance text-4xl font-semibold tracking-tight sm:text-5xl">
        <slot></slot>
      </h2>
    </div>
    <p
      class="flex justify-center sm:justify-start opacity-80 font-medium text-md sm:text-lg text-center text-pretty sm:text-left"
    >
      <slot name="subheader"></slot>
    </p>
  </div>
</template>
